<template>
    <section id="section">
        <header class="header">唯舞用户隐私政策</header>
        <article class="content" v-html="content" />
    </section>
</template>

<script>
    import { index } from '@/api/user-privacy-policy';

    export default {
        data: () => ({
            isLoading: false,
            content: '',
        }),
        async beforeMount() {
            this.isLoading = true;
            const { data, isError} = await index();
            this.isLoading = false;

            if (isError) return;

            this.content = data.content.replace(/\n/g, '<p class="br"></p>');
        },
    }
</script>

<style scoped>
    @import 'index.css';
</style>



// WEBPACK FOOTER //
// src/components/user-privacy/index.vue